import { axiosInstanceWebsite } from "../instance";
import { AxiosResponse } from "../interface";
import { VideoType } from "../../store/adsPageStore";
import { Narrative } from "../../store/adsPageStore";

export interface ParameterPrompt {
  product_name: string;
  product_description: string;
  language?: string;
  sales_angle: string;
  ads_type: VideoType;
  ads_style: string[];
}
export interface GenerateNarrativeRequest {
  product_id?: string | null;
  parameter_prompt: ParameterPrompt;
}

export interface UpdateNarrativeRequest {
  product_id?: string;
  narrative_name?: string;
  style?: string;
  video_type?: VideoType;
  content_narrative?: string;
}

export const generateNarrative = async (request: GenerateNarrativeRequest) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `ads/generate-narrative/generate`,
    request,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response;
};

export const updateNarrative = async (
  narrativeId: string,
  request: Narrative
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.patch(
    `ads/narrative/${narrativeId}`,
    request,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const getNarrativeByUser = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `ads/narrative/full`
  );
  return response.data;
};

export const deleteNarrative = async (narrativeId: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.delete(
    `ads/narrative/${narrativeId}`
  );
  return response;
};
